import React, { useCallback, useEffect } from 'react'
import { FormControl, FormControlLabel, Grid, IconButton, InputAdornment, Radio, RadioGroup, TextField, Typography } from '@material-ui/core'
import { SelecionarData } from 'components'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import Autocomplete from '@material-ui/lab/Autocomplete'
import DeleteIcon from '@material-ui/icons/Delete'
import { useCasoService } from 'hooks/useCasoService'

export const FormToxicologia = (props) => {
  moment.locale('pt-br', localization)
  const { form, handleChange, exameSolicitado, listaVitima, idCaso, pendenteConfirmacao } = props
  const casoService = useCasoService()

  const fetchCaso = useCallback(async () => {
    if (idCaso) {
      const caso = await casoService.listarCasoAsync(idCaso)
      if (!form.descricaoCaso) {
        handleChange('descricaoCaso', caso.descricao)
      } else {
        handleChange('descricaoCaso', exameSolicitado?.descricaoCaso)
      }
    }
  }, [idCaso])

  useEffect(() => {
    fetchCaso()
  }, [fetchCaso])

  const handleClearOutroObjetivo = () => {
    handleChange('tipoCaso', null)
  }

  const getLabelTipoCaso = (value) => {
    if (value === 'ACIDENTE_TRANSITO') {
      return 'Acidente de trânsito'
    }

    if (value === 'SUICIDIO') {
      return 'Suicídio'
    }

    if (value === 'HOMICIDIO') {
      return 'Homicídio'
    }

    if (value === 'AFOGAMENTO') {
      return 'Afogamento'
    }

    if (value === 'QUEDA') {
      return 'Queda'
    }

    if (value === 'A_ESCLARECER') {
      return 'A esclarecer'
    }

    if (value === 'OUTRO') {
      return 'Outro'
    }
    return ''
  }

  return (
    <>
      {!pendenteConfirmacao && (
        <>
          <Grid item md={6} sm={6} xs={12}>
            <Autocomplete
              name="vitima"
              value={form.vitima}
              noOptionsText="Sem informações"
              options={listaVitima || []}
              onChange={(event, newValue) => handleChange('vitima', newValue)}
              required
              getOptionLabel={(option) => {
                if (Object.prototype.hasOwnProperty.call(option, 'nic')) return `CADÁVER - Nome: ${option.nome ? option.nome?.toUpperCase() : 'NÃO IDENTIFICADO'} - NIC: ${option.nic ? option.nic : 'NÃO INFORMADO'}`
                if (Object.prototype.hasOwnProperty.call(option, 'cpf')) return `PERICIANDO - ${option.nome ? `Nome: ${option.nome}` : `Alcunha: ${option.alcunha}` || 'NÃO INFORMADO'} - CPF: ${option.cpf || 'NÃO INFORMADO'}`
              }}
              renderOption={(option) => {
                if (Object.prototype.hasOwnProperty.call(option, 'nic')) return `CADÁVER - Nome: ${option.nome ? option.nome?.toUpperCase() : 'NÃO IDENTIFICADO'} - NIC: ${option.nic ? option.nic : 'NÃO INFORMADO'}`
                if (Object.prototype.hasOwnProperty.call(option, 'cpf')) return `PERICIANDO - ${option.nome ? `Nome: ${option.nome}` : `Alcunha: ${option.alcunha}` || 'NÃO INFORMADO'} - CPF: ${option.cpf || 'NÃO INFORMADO'}`
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="VÍTIMA"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
          </Grid>
          {(form.vitima && form.vitima?.nic) &&(
            <Grid item md={6} sm={6} xs={12}>
              <SelecionarData withoutTime dataBD={form.dataObito} callback={(data) => handleChange('dataObito', data)} label="DATA DO ÓBITO" shrink md={12} sm={12} xs={12} />
            </Grid>
          )}
        </>
      )}

      {form.tipoCaso !== 'OUTRO' ? (
        <Grid item md={12} sm={12} xs={12}>
          <Autocomplete
            name="tipoCaso"
            value={form.tipoCaso}
            noOptionsText="Sem informações"
            options={['ACIDENTE_TRANSITO', 'SUICIDIO', 'HOMICIDIO', 'AFOGAMENTO', 'QUEDA', 'A_ESCLARECER', 'OUTRO']}
            onChange={(event, newValue) => handleChange('tipoCaso', newValue)}
            required
            getOptionLabel={(option) => {
              return getLabelTipoCaso(option)
            }}
            renderOption={(option) => {
              return getLabelTipoCaso(option)
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                required
                variant="outlined"
                label="TIPO DE OCORRÊNCIA"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </Grid>
      ) : (
        <Grid item md={12} sm={12} xs={12}>
          <TextField
            label="TIPO DE OCORRENCIA -  TEXTO LIVRE"
            name="outroTipoCaso"
            variant="outlined"
            value={form.outroTipoCaso}
            onChange={(event) => {
              handleChange('outroTipoCaso', event.target.value)
            }}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <IconButton onClick={(e) => handleClearOutroObjetivo()}>
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      )}
      <Grid item md={4} sm={4} xs={12}>
        <TextField
          label="SUBSTÂNCIA ENVOLVIDA"
          name="substanciaEnvolvida"
          variant="outlined"
          value={form.substanciaEnvolvida}
          onChange={(event) => {
            handleChange('substanciaEnvolvida', event.target.value)
          }}
          required
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      {!pendenteConfirmacao && (
        <>
          <Grid item md={4} sm={4} xs={12}>
            <SelecionarData withoutTime dataBD={null} callback={(data) => handleChange('dataColeta', data)} label="DATA DA COLETA" required shrink md={12} sm={12} xs={12} />
          </Grid>
          <Grid item md={4} sm={4} xs={12}>
            <TextField
              label="HORA DA COLETA"
              name="horaColeta"
              variant="outlined"
              value={form.horaColeta}
              onChange={(event) => {
                handleChange('horaColeta', event.target.value)
              }}
              required
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </>
      )}

      <Grid item container md={12} sm={12} xs={12} spacing={1}>
        <Grid item md={12} sm={12} xs={12}>
          <Typography variant="body2" style={{ fontWeight: 500, color: 'rgba(0, 0, 0, 0.54)' }}>Suspeita de intoxicação?</Typography>
        </Grid>
        <Grid item container md={12} sm={12} xs={12} spacing={2} style={{ marginTop: '4px' }}>
          <Grid item md={4} sm={4} xs={12}>
            <FormControl component="fieldset" fullWidth>
              <RadioGroup
                aria-label="suspeita-intoxicacao"
                name="suspeitaIntoxicacao"
                value={form.suspeitaIntoxicacao || null}
                onChange={(event) => {
                  handleChange('suspeitaIntoxicacao', event.target.value)
                }}
                style={{ display: 'flex', flexDirection: 'row' }}
              >
                <FormControlLabel value="NÃO INFORMADO" control={<Radio />} label={<Typography variant="body2">NÃO INFORMADO</Typography>} />
                <FormControlLabel value="SIM" control={<Radio />} label={<Typography variant="body2">SIM</Typography>} />
                <FormControlLabel value="NÃO" control={<Radio />} label={<Typography variant="body2">NÃO</Typography>} />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item md={8} sm={8} xs={12}>
            <TextField
              disabled={form.suspeitaIntoxicacao !== 'NÃO'}
              label="JUSTIFICATIVA PARA A SOLICITAÇÃO"
              fullWidth
              name="justificativaSolicitacao"
              variant="outlined"
              value={form.justificativaSolicitacao}
              onChange={(event) => {
                handleChange('justificativaSolicitacao', event.target.value)
              }}
              required
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      {!pendenteConfirmacao && (
        <Grid item container md={12} sm={12} xs={12} spacing={1}>
          <Grid item md={12} sm={12} xs={12}>
            <Typography variant="body2" style={{ fontWeight: 500, color: 'rgba(0, 0, 0, 0.54)' }}>A causa depende do exame toxicológico?</Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12} style={{ marginTop: '4px' }}>
            <FormControl component="fieldset" fullWidth>
              <RadioGroup
                aria-label="exameToxicologico-essencial"
                name="exameToxicologicoEssencial"
                value={form.exameToxicologicoEssencial || null}
                onChange={(event) => {
                  handleChange('exameToxicologicoEssencial', event.target.value)
                }}
                style={{ display: 'flex', flexDirection: 'row' }}
              >
                <FormControlLabel value="NÃO INFORMADO" control={<Radio />} label={<Typography variant="body2">NÃO INFORMADO</Typography>} />
                <FormControlLabel value="SIM" control={<Radio />} label={<Typography variant="body2">SIM</Typography>} />
                <FormControlLabel value="NÃO" control={<Radio />} label={<Typography variant="body2">NÃO</Typography>} />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      )}

      <Grid item container md={12} sm={12} xs={12} spacing={1}>
        <Grid item md={12} sm={12} xs={12}>
          <Typography variant="body2" style={{ fontWeight: 500, color: 'rgba(0, 0, 0, 0.54)' }}>Recebeu tratamento/socorro?</Typography>
        </Grid>
        <Grid item container md={12} sm={12} xs={12} spacing={2} style={{ marginTop: '4px' }}>
          <Grid item md={4} sm={4} xs={12}>
            <FormControl component="fieldset" fullWidth>
              <RadioGroup
                aria-label="recebeu-socorro"
                name="recebeuSocorro"
                value={form.recebeuSocorro || null}
                onChange={(event) => {
                  handleChange('recebeuSocorro', event.target.value)
                }}
                style={{ display: 'flex', flexDirection: 'row' }}
              >
                <FormControlLabel value="NÃO INFORMADO" control={<Radio />} label={<Typography variant="body2">NÃO INFORMADO</Typography>} />
                <FormControlLabel value="SIM" control={<Radio />} label={<Typography variant="body2">SIM</Typography>} />
                <FormControlLabel value="NÃO" control={<Radio />} label={<Typography variant="body2">NÃO</Typography>} />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item md={8} sm={8} xs={12}>
            <TextField
              disabled={form.recebeuSocorro !== 'SIM'}
              label="QUANTO TEMPO DESDE O TRATAMENTO/SOCORRO"
              fullWidth
              name="tempoSocorro"
              variant="outlined"
              value={form.tempoSocorro}
              onChange={(event) => {
                handleChange('tempoSocorro', event.target.value)
              }}
              required
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item container md={12} sm={12} xs={12} spacing={1}>
        <Grid item md={12} sm={12} xs={12}>
          <Typography variant="body2" style={{ fontWeight: 500, color: 'rgba(0, 0, 0, 0.54)' }}>Recebeu administração medicamentosa?</Typography>
        </Grid>
        <Grid item container md={12} sm={12} xs={12} spacing={2} style={{ marginTop: '4px' }}>
          <Grid item md={4} sm={4} xs={12}>
            <FormControl component="fieldset" fullWidth>
              <RadioGroup
                aria-label="recebeu-medicamento"
                name="recebeuMedicamento"
                value={form.recebeuMedicamento || null}
                onChange={(event) => {
                  handleChange('recebeuMedicamento', event.target.value)
                }}
                style={{ display: 'flex', flexDirection: 'row' }}
              >
                <FormControlLabel value="NÃO INFORMADO" control={<Radio />} label={<Typography variant="body2">NÃO INFORMADO</Typography>} />
                <FormControlLabel value="SIM" control={<Radio />} label={<Typography variant="body2">SIM</Typography>} />
                <FormControlLabel value="NÃO" control={<Radio />} label={<Typography variant="body2">NÃO</Typography>} />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item md={8} sm={8} xs={12}>
            <TextField
              disabled={form.recebeuMedicamento !== 'SIM'}
              label="QUAIS MEDICAMENTOS"
              fullWidth
              name="medicamentos"
              variant="outlined"
              value={form.medicamentos}
              onChange={(event) => {
                handleChange('medicamentos', event.target.value)
              }}
              required
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}
